<template>
    <div :class="$style.wrapper">
        <div :class="$style.avatars">
            <template
                v-for="(img, index) in images"
                :key="index"
            >
                <div :class="$style.avatar_base" />
                <img
                    :src="img"
                    alt="Avatar"
                    loading="lazy"
                />
            </template>
        </div>
        <Typography
            type="label"
            size="m"
            :responsive="false"
            :class="$style.playing_friends"
        >
            {{ phrase }}
        </Typography>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Typography from '@/components/Typography.vue'
import { useTr } from '@/composables/use-tr'
import { shuffle } from '@/utils/helpers'

const props = withDefaults(defineProps<{ shortCount?: number; isTrendingGame?: boolean }>(), {
    shortCount: 3,
})

const ctx = require.context('@/assets/avatars?file', false, /\.webp$/i)
const allImages: string[] = ctx.keys().map((key) => ctx(key))
const tr = useTr()

const images = computed(() => shuffle(allImages).slice(0, props.shortCount))
const phrase = computed(() => {
    if (props.isTrendingGame) {
        return tr('playingFriends.phrase_trending')
    }
    return shuffle([
        tr('playingFriends.phrase_1'),
        tr('playingFriends.phrase_3'),
        tr('playingFriends.phrase_4'),
        tr('playingFriends.phrase_5'),
    ])[0]
})
</script>
<style module>
.wrapper {
    display: none;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 40px;
}

.avatars {
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: row-reverse;
    z-index: 0;
}

.avatar_base {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    background: linear-gradient(var(--purple-600) 0 40%, #9cff00 60%);
}

.avatars img {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    display: block;
    border: 2px solid black;
    position: absolute;
    z-index: 1;
}

.avatars img:nth-of-type(1) {
    left: -12px;
}

.avatars img:nth-of-type(2) {
    left: 7px;
}

.avatars img:nth-of-type(3) {
    left: 26px;
}

.avatar_base:not(:last-child) {
    margin-left: -13px;
}

.avatar_base,
.avatars img {
    opacity: 0;
    transform: translateY(16px);
    animation: avatarsFade 300ms ease-out 2000ms forwards;
}

@keyframes avatarsFade {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.playing_friends {
    color: var(--white-80);
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    clip-path: inset(0 100% 0 0);
    animation: revealText 500ms ease-out 2150ms forwards;
}

@keyframes revealText {
    from {
        clip-path: inset(0 100% 0 0);
    }
    to {
        clip-path: inset(0 0 0 0);
    }
}

@keyframes revealBorder {
    to {
        --reveal: 100%;
    }
}

@media (--desktop-medium-plus) {
    .wrapper {
        display: flex;
    }
}
</style>
